import { render, staticRenderFns } from "./AuthXWidgetPreview.vue?vue&type=template&id=205837bb&scoped=true"
import script from "./AuthXWidgetPreview.vue?vue&type=script&lang=js"
export * from "./AuthXWidgetPreview.vue?vue&type=script&lang=js"
import style0 from "./AuthXWidgetPreview.vue?vue&type=style&index=0&id=205837bb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205837bb",
  null
  
)

export default component.exports